import $ from 'jquery';
import _ from 'underscore';
import Ps from 'perfect-scrollbar';
import Form from 'jquery-form';

class CalculatorsController {

    constructor() {
        //init properties
        this.Form = Form(document, $);

        $(document).ready(() => {
            this.registerElements();
            if (this.checkPrerequisites()) {
                this.initScrollBars();
                this.initScrollBarsResult();
                this.hookListeners();
                this.checkURLParams();
                this.hideCalculatorTextIntro();
            }
        })
    }

    /**
     * Register all DOM elements into properties
     */
    registerElements() {
        // JS template for result

        const itemTemplate = $('script.c-gematry-calculators__result-template');
        if (itemTemplate.length) {
            this.resultTemplate = _.template(itemTemplate.html());
        }

        //DOM elements
        this.$container = $('.js-calculators-section-container');
        this.$filterForm = this.$container.find('.js-calculator-search-form');
        this.$filter = this.$filterForm.find('.js-calculator-search-field');
        this.$calculatorsForm = this.$container.find('.js-calculators-form');
        this.$selectedContainer = this.$container.find('.js-selected-calculators-container');
        this.$resultsContainer = this.$container.find('.js-results-container');
        this.$listContainer = this.$container.find('.js-calculator-list-container');
        this.$list = this.$container.find('.js-calculator-list');
        this.$listItems = this.$container.find('.js-calculator-list-item');
        this.$wordToCalculate = $('.c-gematry-calculators__calculation');
        this.$selectedWord = $('.c-gematry-calculators__selected-word');
        this.$activeClear = $('.c-gematry-calculators__clear-selected');
        this.$clearResults = $('.js-clear-button');
        this.getAll = $('#getAllCalculators');
        this.submitButton = $('.c-gematry-calculators__text-button');
        this.closeCalculatorText = $('.js-close-calc-text svg');
        this.calculatorTextContainer = $('.c-gematry-calculators__calculator-text-intro');
        this.calculatorNamesList = this.$list.find('.js-calculator-title').map(function (ind, el) {
            return $(el).text().toLowerCase();
        });

        this.showLoaderEvent = new Event('loader.show');
        this.hideLoaderEvent = new Event('loader.hide');
    }

    /**
     * Check if all DOM elements needed are present
     *
     * @return {boolean}
     */
    checkPrerequisites() {
        return this.$container.length === 1 && this.$filterForm.length === 1 && this.$filter.length === 1 && this.$calculatorsForm.length === 1 && this.$selectedContainer.length === 1 && this.$list.length === 1 && this.calculatorNamesList.length > 0;
    }

    initScrollBars() {
        this.sdfscrollbar = new Ps(this.$listContainer[0]);
    }

    initScrollBarsResult() {
        this.scrollbar = new Ps(this.$resultsContainer[0]);
    }

    /**
     * Initialize all DOM event handlers
     */
    hookListeners() {
        //click on list items
        this.$list.find('li').click(e => {
            let val = $(e.currentTarget).data('target');
            this.activateCalculator(val);
        });
        this.getAll.click(e => {
            this.$listItems.click();
        });
        //click on selected calculator item
        this.$selectedContainer.find('input[type="checkbox"]').click(e => {
            let val = $(e.currentTarget).val();
            let listEl = this.$list.find('li[data-target="' + val + '"]');
            if (listEl.length > 0) {
                listEl.removeClass('c-gematry-calculators__list-item--selected');
            }
        });
        // clear result button
        this.$clearResults.click(e => {
            this.$activeClear.removeClass('c-gematry-calculators__clear-active');
            this.$selectedContainer.find('.c-gematry-calculators__calc-item-input').prop("checked", false);
            this.$activeClear.removeClass('c-gematry-calculators__active--clear');
            this.$list.find('li.c-gematry-calculators__list-item--selected').removeClass('c-gematry-calculators__list-item--selected');
            $('.c-gematry-calculators__results-item').remove();
            $('.c-gematry-calculators__selected-word').remove();
            this.$resultsContainer[0].scrollTop = 0;
            this.$clearResults.parent().fadeOut();

            return false;
        });
        //init jQuery form

        this.Form(this.$calculatorsForm).ajaxForm({
            beforeSubmit: e => {
                if (this.$selectedContainer.find('input:checked').length < 1) {
                    this.showError('At least one calculator needs to be submitted');
                    return false;
                }

                document.dispatchEvent(this.showLoaderEvent);
                return true;
            },
            success: response => {
                if (response.success) {
                    document.dispatchEvent(this.hideLoaderEvent);

                    this.$clearResults.parent().css('display', 'flex');
                    this.$activeClear.addClass('c-gematry-calculators__clear-active');
                    // this.$selectedWord.html(this.$wordToCalculate.val());
                    this.resultData = response.data;
                    //console.log('Result data', this.resultData);
                    this.$resultsContainer.prepend(this.resultTemplate({
                        data: this.resultData
                    }));

                    this.$saveResultBtns = $('.js-save-calculator-result');

                    this.$saveResultBtns.click((e) => {
                        let saveResultBtn = $(e.currentTarget);
                        let dataSet = this.resultData[saveResultBtn.data('index')];
                        let word = dataSet['value'];
                        let result = dataSet['result'];
                        let calculatorName = dataSet['calculator_name'];
                        let breakdown = dataSet['breakdown'];

                        document.dispatchEvent(this.showLoaderEvent);

                        if (breakdown) {
                            breakdown = breakdown.map((el) => {
                                let key = Object.keys(el)[0];
                                return el[key];
                            });
                            breakdown = '( ' + breakdown.join(' + ') + ' )';
                        } else {
                            breakdown = '';
                        }


                        var data = {
                            'action': 'calculator_result_ajax_request',
                            'post_type': 'POST',
                            'word': word,
                            'result': result,
                            'calculatorName': calculatorName.trim(),
                            'breakdown': breakdown.trim()
                        };
                        var url = '/wp-admin/admin-ajax.php';


                        $.post(url, data, (response) => {
                            document.dispatchEvent(this.hideLoaderEvent);
                            $(saveResultBtn).html('SAVED');
                            $(saveResultBtn).prop("disabled", true);
                            $(saveResultBtn).css("opacity", 1);
                        }, 'json');
                    });
                    this.hookPopUpListeners();
                }
            }
        });

        this.$filter.on('search keyup', e => {
            this.filterCalculatorList($(e.currentTarget).val().toLowerCase())
        });

        this.$wordToCalculate.keyup((e) => {
            const hasValue = e.currentTarget.value ? true : false;
            this.submitButton.toggleClass('c-gematry-calculators__text-button--active', hasValue);
        });
    }

    activateCalculator(name) {
        if (name) {
            this.$list.find('li[data-target="' + name + '"]').addClass('c-gematry-calculators__list-item--selected');
            this.$selectedContainer.find('input[value="' + name + '"]').prop("checked", true)
        }
    }

    hookPopUpListeners() {
        $('.js-calculated-item-unlock, .js-calculated-item-save').off('click').click(() => {
            //send an event for the popup to open
            $(document).trigger('popup.open', {
                hidePlan: ['basic', 'pro']
            })
        })
    }

    /**
     * Check if there are any calculators coming in from a URL param
     *
     */
    checkURLParams() {
        let search = location.search;
        let params = new URLSearchParams(search);
        if (params.get('calculator')) {
            this.activateCalculator(params.get('calculator'))
        }
    }

    hideCalculatorTextIntro() {
        if(localStorage.getItem('calcs')) {
            this.calculatorTextContainer.remove();
        }
        else {
            this.closeCalculatorText.click(() => {
                this.calculatorTextContainer.show();
                localStorage.setItem('calcs', 'hide_calculator_intro_text');

                $.when(this.calculatorTextContainer.fadeOut())
                    .then(() => this.calculatorTextContainer.remove());
            });
        }
    }

    filterCalculatorList(filter) {
        if (!filter) {
            //show all calculators
            this.$listItems.removeClass('c-gematry-calculators__list-item--hidden')
        } else {
            //filter
            this.$listItems.each((ind, el) => {
                if (this.calculatorNamesList[ind].indexOf(filter) === -1) {
                    $(el).addClass('c-gematry-calculators__list-item--hidden')
                }
            });
        }
    }

    /**
     * Displays an error to the user
     *
     * @param message
     */
    showError(message) {
        //TODO: Replace the alert with an actual message popup or something similar
        alert(message);
    }
}

export default CalculatorsController;
